<ns-grid 
  [name]="configs.gridName"
  [gridTitle]="configs.gridTitle" [columns]="configs.columns"
  [data]="trafficHistory"
  [config]="configs.headerOptions"
  [gridOptions]="configs.options"
  [loading]="loading"
  [rowSelection]="configs.rowSelection"
  (refresh)="reload.emit()">
</ns-grid>
